module.exports = __webpack_public_path__ + "img/scallable.b0a4dea9.png";